import React from 'react'

const Experience = () => {
  return (
    <div className=' bg-[#142d4c]' id='exp'>
        <h1 className=' flex justify-center items-center w-screen mb-10 pt-10 text-3xl text-white font-extrabold'>Where I've worked</h1>
        
        <div className=' flex justify-center items-center '>
            <div className=' w-1 h-[250px] bg-slate-300'>

            </div>
            <div>
                <h2 className=' pl-4 text-xl font-semibold text-white'>Backend Developer Intern @HireXzo Solutions</h2>
                <p className=' pl-4 text-white text-sm'>SEP 2023 - FEB 2024</p>
                <p className=' text-gray-100 w-full lg:w-[600px] text-justify bg-blue-950 p-4 rounded-md'>
                    During my tenure as a Backend Developer Intern at HireXzo Solutions, I played a pivotal role in the development and maintenance of backend systems and databases. My responsibilities included the creation and maintenance of APIs, with hands-on experience in working with both MongoDB and SQL databases. This internship not only honed my skills in backend development but also provided practical experience in ensuring robust and efficient data management solutions. I am enthusiastic about leveraging this experience to contribute to innovative projects and further advance my expertise in the field.
                </p>
            </div>

        </div>
    </div>
  )
}

export default Experience